import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"

const initialState = {
  order: {},
  orders: Array(0),
}

export const fetchOrders = createAsyncThunk("fetchOrders", async () => {
  try {
    const token = window.localStorage.getItem("token")
    const response = await axios.get("/api/orders/all", {
      headers: {
        authorization: token,
      },
    })
    return response.data
  } catch (err) {
    console.log(err)
  }
})

export const fetchOrder = createAsyncThunk("fetchOrder", async (id) => {
  try {
    const token = window.localStorage.getItem("token")
    const response = await axios.get(`/api/orders/${id}`, {
      headers: {
        authorization: token,
      },
    })
    return response.data
  } catch (err) {
    console.log(err)
  }
})

export const deleteOrder = createAsyncThunk("deleteOrder", async (orderId) => {
  try {
    const token = window.localStorage.getItem("token")
    await axios.delete(`/api/orders/${orderId}`, {
      headers: {
        authorization: token,
      },
    })
    return orderId
  } catch (err) {
    console.log(err)
  }
})

const ordersSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {
    setOrder: (state, action) => {
      state.order = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrders.fulfilled, (state, action) => {
        return { ...state, orders: action.payload }
      })
      .addCase(fetchOrder.fulfilled, (state, action) => {
        return { ...state, order: action.payload }
      })
      .addCase(deleteOrder.fulfilled, (state, action) => {
        state.orders = state.orders.filter(
          (order) => order.id !== action.payload
        )
      })
  },
})

export default ordersSlice.reducer
